import Model from '@/lib/data/Model';
import FileTag from './FileTag';

class FileStorageItem extends Model {
    static idProperty = 'id';

    fields = [
        { name: 'id' },
        { name: 'name' },
        { name: 'mime_type' },
        { name: 'path' },
        { name: 'size', type: 'float' },
        { name: 'ref_table' },
        { name: 'bucket' },
        { name: 'record_date_utc' },
        { name: 'base64' },
        { name: 'uid' },
        {
            name: 'tags',
            association: {
                type: 'many',
                model: FileTag,
            },
        },
    ];

    /**
     * Create the User object
     *
     * @param {Object} data - Seed data for this object.
     */
    constructor(data) {
        super(data);
        this.init();
    }

    get sizeInKb() {
        return (this.size / 1024).toFixed(1);
    }

    get sizeInMb() {
        return (this.size / 1024 / 1024).toFixed(1);
    }

    get recordType() {
        if (this.ref_table == 'vrs_storage') {
            return 'Call';
        }
        if (this.ref_table == 'visit') {
            return this.ref_table;
        }
        return 'Form';
    }

    get url() {
        return `${window.location.origin}/file/url?id=${
            this.id
        }&auth_token=${Model.getAuthToken()}`;
    }

    get type() {
        if (this.mime_type.indexOf('image') > -1) {
            return 'image';
        }
        if (this.mime_type.indexOf('video') > -1) {
            return 'video';
        }
        return 'other';
    }

    get src() {
        return `${window.location.origin}/file?id=${this.id}&auth_token=${Model.getAuthToken()}`;
    }

    get thumbSrc() {
        return `${window.location.origin}/file?id=${
            this.id
        }&w=150&h=150&auth_token=${Model.getAuthToken()}`;
    }

    get isImage() {
        return this.mime_type.indexOf('image') > -1;
    }

    get isVideo() {
        return this.mime_type.indexOf('video') > -1;
    }

    get isAudio() {
        return this.mime_type.indexOf('audio') > -1;
    }

    getImageSrc(w, h) {
        return `${window.location.origin}/file?id=${
            this.id
        }&w=${w}&h=${h}&auth_token=${Model.getAuthToken()}`;
    }

    api = [
        {
            name: 'remove',
            url: '/filemanager/delete',
            params: ['id'],
        },
        {
            name: 'removesoft',
            url: '/filemanager/deletesoft',
            params: ['id'],
        },
        {
            name: 'saveorupdatetags',
            url: '/file/tags/saveorupdatetags',
            associated: true,
        },
        {
            name: 'getById',
            url: '/filemanager/getById',
            params: ['id'],
        },
        {
            name: 'destroy',
            url: '/mcrcustomeroper/file/delete',
        },
    ];
}

export default FileStorageItem;
